// 3rd party imports
import { DeviceDetectorService } from 'ngx-device-detector';
import * as i0 from "@angular/core";
import * as i1 from "ngx-device-detector";
export class DeviceService {
    constructor(deviceDetectorService) {
        this.deviceDetectorService = deviceDetectorService;
    }
    get deviceInfomation() {
        if (this._deviceInfo === undefined) {
            this._deviceInfo = this.deviceDetectorService.getDeviceInfo();
        }
        return this._deviceInfo;
    }
}
DeviceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeviceService_Factory() { return new DeviceService(i0.ɵɵinject(i1.DeviceDetectorService)); }, token: DeviceService, providedIn: "root" });
